// Basic hyphens style
export var baseHyphensStyle = "\n  hyphens: auto;\n";